<div class="with-floating-button">
    <div *ngIf="true" class="content">
        <page-header (onGoBack)="onGoBack()" [isPending]="isLoading" (onSelectedItemChange)="onSelectedItemChange($event)"
                     [listeItems]="listeTabItems"
                     [title]="'profilUser.mobile.title' | translate">
        </page-header>

        <div [hidden]="selectedItem.code != 'CONNECTED_DEVICES'">
            <list-view *ngIf="liste" [liste]="liste"></list-view>
        </div>

        <div [hidden]="selectedItem.code != 'CONNECT_DEVICE'">
            <mat-card>
                <mat-card-title>
                    <span [translate]="'profilUser.mobile.telechargerApp'"></span>
                </mat-card-title>
                <mat-card-content class="mobileDownloadContent">
                    <div class="row">
                        <div class="col-md-2 mobileLogoContainer">
                            <img class="mobileLogo" alt="Cegid NPiO" src="/assets/logo/logo_mobile.png"/>
                        </div>
                        <div class="col-md-10 d-flex flex-column justify-content-center">
                            <div class="mobileTextBlock">
                                <p [translate]="'profilUser.mobile.downloadMessage'"></p>
                                <div class="mobileCenterImage">
                                    <div class="mobileStoresRow">
                                        <a href="https://apps.apple.com/fr/app/cegid-notilus-secteur-public/id6746334472" target="_new">
                                            <img alt="Get it on App Store" src="/assets/logo/app_store.svg" height="50"/>
                                        </a>
                                        <a href="https://play.google.com/store/apps/details?id=com.notilus.pio" target="_new">
                                            <img alt="Get it on Google Play" src="/assets/logo/google_play.png" height="50"/>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-title>
                    <span [translate]="'profilUser.mobile.connecterApp'"></span>
                </mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <div class="col-md-2"></div>
                        <div class="col-md-10">
                            <div class="mobileTextBlock">
                                <span [translate]="'profilUser.mobile.scanQRMessage'"></span>

                                <div class="mobileCenterImage">
                                    <qrcode *ngIf="qrCode" [errorCorrectionLevel]="'H'" [qrdata]="qrCode" [width]="256"></qrcode>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
    <floating-button [hidden]="selectedItem?.code != 'CONNECTED_DEVICES'" [isPending]="isLoading" [listeActions]="listeActions"></floating-button>
</div>
<please-wait *ngIf="!true" class="content"></please-wait>
